module.exports = __webpack_public_path__ + "static/google_allow_access-c04127394445f23b447de553016442d0.png";